<template>
  <div style="margin-bottom: 100px;">
    <div
      class="container"
      :class="$vuetify.breakpoint.smAndDown ? 'px-0' : 'px-4'"
      :style="$vuetify.breakpoint.smAndDown ? '' : 'max-width: 1100px;'"
    >
      <AlertActivateTwoStepsAuthentication
        v-if="$store.state.operators.multifactor == 1"
      />

      <CarouselAndPopup v-show="$route.name === 'casinoLobby'" />

      <div
        class="my-2"
        :class="$vuetify.breakpoint.smAndDown ? 'px-4' : 'px-0'"
      >
        <!-- Menu de categorias -->
        <MenuCategories
          v-show="
            $route.name === 'casinoLobby' ? indexedDbFetching === false : true
          "
          :categories="menuCategoriesOrProviders"
          :searchDialog="searchDialog"
          @openSearchDialog="openSearchDialog"
        />
        <!-- Slider dos provedores -->
        <ProvidersSlider
          v-show="
            $route.name === 'casinoLobby' &&
              indexedDbFetching === false &&
              fetchingLobby === false &&
              providersWithGames.length > 0
          "
          :providers="providersWithGames"
        />
      </div>

      <!-- Slider de Games -->
      <!-- Skeleton Mobile -->
      <div
        v-if="
          $vuetify.breakpoint.xs && (games.length === 0 || indexedDbFetching)
        "
        class="px-5 pt-3"
        :style="{ display: showSliderCards }"
      >
        <v-skeleton-loader
          type="image"
          width="100%"
          style="border-radius: 8px;"
          :style="{ height: 'calc((100vw - 200px) + 200px)' }"
        ></v-skeleton-loader>
      </div>
      <!-- Skeleton Desktop -->
      <div
        v-else-if="
          $vuetify.breakpoint.smAndUp &&
            (games.length === 0 || indexedDbFetching)
        "
        class="pt-4"
        :class="{ 'px-5': $vuetify.breakpoint.sm || $vuetify.breakpoint.md }"
        style="gap: 20px;"
        :style="{ display: showSliderCards }"
      >
        <v-skeleton-loader
          v-for="skeleton in 3"
          :key="skeleton"
          type="image"
          width="33%"
          style="border-radius: 8px;"
          :style="{
            height:
              $vuetify.breakpoint.width > 1100
                ? 'calc((1100px - 40px) / 3 + 40px)'
                : $vuetify.breakpoint.width > 960
                ? 'calc((960px - 40px) / 3 + 40px)'
                : 'calc((100vw - 56px) / 3 + 40px)',
          }"
        ></v-skeleton-loader>
      </div>
      <SliderCards
        v-else-if="$route.name === 'casinoLobby'"
        classElement="sliderCardsCasino"
        :games="games.slice(0, 12)"
        :style="{ display: showSliderCards }"
      />
    </div>

    <div
      :class="{
        'px-0': !$vuetify.breakpoint.mobile,
        container: modeViewGame === '',
      }"
      :style="
        $vuetify.breakpoint.xs
          ? 'padding: 0px;'
          : modeViewGame === 'theater'
          ? ''
          : 'max-width: 1100px;'
      "
    >
      <div class="wrapContent" :class="{ 'px-4': !$vuetify.breakpoint.mobile }">
        <template v-if="$route.name === 'casinoLobby'">
          <!-- Progress -->
          <div
            v-if="fetchingLobby || indexedDbFetching"
            class="d-flex justify-center pt-6 mt-12"
          >
            <v-progress-circular
              :size="32"
              color="primary"
              indeterminate
            ></v-progress-circular>
          </div>

          <!-- Loop das categorias -->
          <div v-if="indexedDbFetching === false">
            <div v-for="(category, index) in slicedCategories" :key="index">
              <v-sheet
                :min-height="sheetMinHeight(category)"
                class="fill-height"
                color="transparent"
              >
                <v-lazy
                  :v-model="
                    activeCategories[$route.params.casinoType][category.name]
                  "
                >
                  <GridHomeCategory
                    :category="category"
                    :providers="providersWithGames"
                  />
                </v-lazy>
              </v-sheet>
            </div>
          </div>

          <!-- alert -->
          <div
            v-if="
              indexedDbFetching === false &&
                slicedCategories.length === 0 &&
                fetchingLobby === false
            "
          >
            <v-alert
              type="info"
              border="left"
              dense
              text
              class="mx-2 mt-4 mb-0"
            >
              {{ $t("newCasino.noGamesFoundLobby") }}
            </v-alert>
          </div>
        </template>

        <SearchDialog
          :dialog="searchDialog"
          :games="games"
          @closeDialog="searchDialog = false"
        />

        <v-fade-transition :hide-on-leave="true">
          <router-view
            :providers="providersWithGames"
            :categories="categories"
            :games="games"
          ></router-view>
        </v-fade-transition>
      </div>
    </div>

    <UnloggedDialog
      :dialog="unloggedDialog"
      :game="unloggedDialogGame"
      @closeDialog="unloggedDialog = false"
    />

    <v-dialog v-if="popup.show" v-model="popup.show" width="512">
      <v-card>
        <v-btn
          depressed
          absolute
          @click="popup.show = false"
          style="z-index: 1"
          icon
        >
          <v-icon>
            mdi-close
          </v-icon>
        </v-btn>
        <a
          :href="popup.url"
          :style="popup.url ? 'cursor:pointer' : 'cursor:auto'"
        >
          <v-img max-height="512" max-width="512" :src="popup.urlImg">
            <template v-slot:placeholder>
              <v-row class="fill-height ma-0" align="center" justify="center">
                <v-progress-circular indeterminate></v-progress-circular>
              </v-row>
            </template>
          </v-img>
        </a>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import AlertActivateTwoStepsAuthentication from "@/components/alert-activate-two-steps-authentication/AlertActivateTwoStepsAuthentication.vue";
import SliderCards from "@/components/casino/SliderCards.vue";
import MenuCategories from "./components/MenuCategories.vue";
import ProvidersSlider from "./components/ProvidersSlider.vue";
import GridHomeCategory from "./components/GridHomeCategory.vue";
import UnloggedDialog from "./components/unloggedDialog";
import SearchDialog from "./components/searchDialog";
import Localbase from "localbase";
import { listGamesFavorites } from "@/util/casino/gameFavorite.js";
import CarouselAndPopup from "@/views/home/events/components/carousel";

export default {
  name: "lobby",
  components: {
    AlertActivateTwoStepsAuthentication,
    SliderCards,
    MenuCategories,
    ProvidersSlider,
    GridHomeCategory,
    UnloggedDialog,
    SearchDialog,
    CarouselAndPopup,
  },
  data: () => ({
    categories: [],
    unloggedDialogGame: {},
    unloggedDialog: false,
    searchDialog: false,
    activeCategories: {
      live: {},
      casino: {},
    },
    games: [],
    gridGamesFavorites: [],
    popup: { show: false, urlImg: "", url: "#" },
  }),
  mounted() {
    this.$root.$on("openUnloggedDialog", (game) => {
      this.unloggedDialogGame = game;
      this.unloggedDialog = true;
    });

    this.$store.commit("setIndexedDbFetching", true);

    setTimeout(() => {
      this.getAllGames();
      this.getProviders();
      this.updateListGamesFavorites();
      this.$store.commit("setCasinoAlphabeticalOrderFilter", "A - Z");
      this.$store.commit("setCasinoProvidersFilter", []);
      this.$store.commit("setModeViewGame", "");
    }, 500);
  },
  watch: {
    $route(newRoute, oldRoute) {
      if (oldRoute.name.includes("casinoGame")) {
        this.$store.commit("setModeViewGame", "");
      }

      if (
        oldRoute.name === "casinoLobby" &&
        newRoute.params.casinoType === oldRoute.params.casinoType
      ) {
        this.updateCategoriesLazyState({
          casinoType: this.$route.params.casinoType,
          categoriesToRender: this.$vuetify.breakpoint.mobile ? 1 : 2,
        });
      }
    },
    "$route.params.casinoType"(newType) {
      this.updateCategoriesLazyState({
        casinoType: newType,
        categoriesToRender: this.$vuetify.breakpoint.mobile ? 1 : 2,
      });

      this.getAllGames();
      this.getProviders();
      this.$store.commit("setCasinoAlphabeticalOrderFilter", "A - Z");
      this.$store.commit("setCasinoProvidersFilter", []);
      this.updateListGamesFavorites();
    },
    "$route.params.category"() {
      this.$nextTick(() => {
        this.$vuetify.goTo(0);
      });
    },
    "$route.params.providerId"() {
      this.$nextTick(() => {
        this.$vuetify.goTo(0);
      });
    },
    gamesFavoritesUpdating() {
      this.updateListGamesFavorites();
    },
    "$store.state.logged.status"() {
      this.updateListGamesFavorites();
    },
  },
  computed: {
    indexedDbFetching() {
      return this.$store.state.indexedDbFetching;
    },
    menuCategoriesOrProviders() {
      if (this.$route.path.includes("providers")) {
        return [
          { name: "Search" },
          { name: this.$t("newCasino.providers") },
          ...this.providersWithGames,
        ];
      }

      return this.categories.length === 0
        ? []
        : [{ name: "Search" }, { name: "Lobby" }, ...this.categories];
    },
    providersWithGames() {
      return this.$store.state.casinoProviders
        .filter((provider) => {
          return this.games.some((game) => game.id_provider === provider.id);
        })
        .map((provider) => {
          return {
            ...provider,
            smallLogo: `https://cdn.softswiss.net/logos/providers_small/white/${provider.key}.svg`,
          };
        });
    },
    slicedCategories() {
      var slice = this.$vuetify.breakpoint.xs ? 24 : 12;

      const listCategoriesWithFavorites = [
        ...this.gridGamesFavorites,
        ...this.categories,
      ];

      return listCategoriesWithFavorites.map((category) => ({
        ...category,
        games: category.games.slice(0, slice).map((game) => {
          const gameWithCategory = this.games.find(
            (_game) => _game.game_id === game.game_id
          );

          return {
            ...game,
            categories: gameWithCategory && gameWithCategory.categories,
          };
        }),
      }));
    },
    showSliderCards() {
      return this.$route.name === "casinoLobby" ? "flex" : "none !important";
    },
    fetchingLobby() {
      return this.$store.state.fetchingCasinoLobby;
    },
    isCasinoType() {
      return this.$route.params.casinoType === "casino";
    },
    modeViewGame() {
      return this.$store.state.modeViewGame;
    },
    gamesFavoritesUpdating() {
      return this.$store.state.gamesFavoritesUpdating;
    },
  },
  methods: {
    async getAllGames() {
      const type = this.$route.params.casinoType;
      const body = {
        domain: this.$domain(),
        live: this.isCasinoType ? 0 : 1,
      };

      this.$store.commit("setIndexedDbFetching", true);

      const db = new Localbase("db");
      let data = await db.collection("casinoData").get();

      if (data) {
        let currentType = data.find((entry) => entry.id === type);

        if (currentType) {
          const now = new Date();
          const expiresAt = new Date(currentType.expiresAt);

          if (expiresAt > now) {
            const games = [];

            currentType.categories.forEach((category) => {
              category.games.forEach((game) => {
                games.push(game);
              });
            });

            this.games = games;
            this.categories = currentType.categories;
            this.$store.commit("setIndexedDbFetching", false);

            currentType.categories = undefined;

            if (data[0]) {
              data[0].categories = undefined;
            }

            if (data[1]) {
              data[1].categories = undefined;
            }

            return;
          }
        }
      }

      this.$store.commit("setIndexedDbFetching", false);
      this.$store.commit("setFetchingCasinoLobby", true);
      this.games = [];
      this.categories = [];

      this.$axios
        .post("casino/gamesAgregation/listByOperator", this.$formdata(body))
        .then(async (res) => {
          const allGames = [];
          const categories = [];
          for (let i = 0; i < res.data.dados.length; i++) {
            const category = res.data.dados[i];
            const games = [];
            for (let j = 0; j < category.games.length; j++) {
              const game = category.games[j];
              const src = this.getGameImage(game);
              const providerImage = this.getProviderImage(game);
              const providerImageColor = this.getProviderImage(game, "color");
              const gameIndex = allGames.findIndex(
                ({ game_id }) => game_id === game.game_id
              );

              const newGame = {
                ...game,
                key: `${game.game_id}-${game.id_provider}`,
                src,
                categoryName: category.name_category,
                providerImage,
                providerImageColor,
                categories: [category.name_category],
              };

              games.push(newGame);

              if (gameIndex === -1) {
                allGames.push(newGame);
              } else {
                allGames[gameIndex].categories = [
                  ...allGames[gameIndex].categories,
                  category.name_category,
                ];
              }
            }
            categories.push({
              name: category.name_category,
              numberOfGames: games.length,
              games,
            });
          }

          this.games = allGames;
          this.categories = categories;

          db.collection("casinoData")
            .get()
            .then((data) => {
              function addMinutes(date, minutes) {
                return new Date(date.getTime() + minutes * 60000);
              }

              const hasCurrentType = data.find((entry) => entry.id === type);
              const newData = {
                categories,
                expiresAt: addMinutes(new Date(), 10),
              };

              if (hasCurrentType) {
                db.collection("casinoData")
                  .doc({ id: type })
                  .update(newData);
              } else {
                db.collection("casinoData").add({
                  id: type,
                  ...newData,
                });
              }
            });
        })
        .catch((err) => {
          this.$store.commit("setNotification", {
            msg: err.response.data.messages.error,
            color: "warning",
          });
        })
        .finally(() => {
          this.$store.commit("setFetchingCasinoLobby", false);
        });
    },
    getProviders() {
      const body = {
        domain: this.$domain(),
      };

      const { isExpired, data } = this.$casinoStorage.get({
        type: "providers",
      });

      if (isExpired === false && data.providers) {
        this.providers = data.providers;
        this.$store.commit("setCasinoProviders", data.providers);
        return;
      }

      this.$axios
        .post(
          "casino/gamesAgregation/listProvidersByOperator",
          this.$formdata(body)
        )
        .then((res) => {
          const providers = res.data.dados.map((provider) => {
            const src = this.getProviderImage(provider);
            const srcColor = this.getProviderImage(provider, "color");

            return {
              id: provider.id,
              key: provider.provider_id,
              name: provider.provider,
              src,
              srcColor,
            };
          });

          this.providers = providers;
          this.$store.commit("setCasinoProviders", providers);

          this.$casinoStorage.set({
            type: "providers",
            fields: { providers },
          });
        })
        .catch((err) => {
          this.$store.commit("setNotification", {
            msg: err.response.data.messages.error,
            color: "warning",
          });
        });
    },
    getGameImage({ provider_id, identifier }) {
      return encodeURI(
        `https://cdn.softswiss.net/i/s3/${provider_id}/${
          identifier.split(":")[1]
        }.png`.replace(/\s/g, "")
      );
    },
    getProviderImage({ provider_id }, type) {
      return encodeURI(
        `https://cdn.softswiss.net/logos/providers/${
          type === "color" ? "color" : "white"
        }/${provider_id}.svg`.replace(/\s/g, "")
      );
    },
    openSearchDialog() {
      this.searchDialog = true;

      if (this.$route.hash === "#search") {
        return;
      }

      this.$router.push({
        path: "#search",
      });
    },
    sheetMinHeight(category) {
      const gamesPerRow = this.$vuetify.breakpoint.mobile ? 12 : 6;
      return category.games.length > gamesPerRow
        ? this.$vuetify.breakpoint.mobile
          ? 300
          : 492
        : this.$vuetify.breakpoint.mobile
        ? 184
        : 266;
    },
    updateCategoriesLazyState({ casinoType, categoriesToRender }) {
      let i = 0;
      for (const category in this.activeCategories[casinoType]) {
        this.activeCategories[casinoType][category] = i < categoriesToRender;
        i++;
      }
    },
    updateListGamesFavorites() {
      const listGamesFavoritesData = listGamesFavorites(
        this.$route.params.casinoType
      );

      if (
        listGamesFavoritesData.length === 0 ||
        !this.$store.state.logged.status
      ) {
        this.gridGamesFavorites = [];
      } else {
        this.gridGamesFavorites = [
          {
            name: this.$t("favorites"),
            games: listGamesFavoritesData,
            numberOfGames: listGamesFavoritesData.length,
            isViewFavorites: true,
          },
        ];
      }
    },
  },
};
</script>
<style scoped>
.v-skeleton-loader.v-skeleton-loader--is-loading >>> .v-skeleton-loader__image {
  height: 100%;
}
</style>
